import isNil from 'lodash/isNil';
import {requiredMessage} from 'utils/const';
import {Data} from '@store/@types/util';

export function validate(schedule) {
  const errors = {};
  ['hour', 'minute'].forEach(prop => {
    if (isNil(schedule[prop])) {
      errors[prop] = requiredMessage;
    }
  });
  return errors;
}

interface TimeInterface {
  hour: number;
  minute: number;
}

export default class Time extends Data<TimeInterface>({
  hour: undefined,
  minute: undefined,
}) {}
